<template>
  <div>
    <!-- 内容区域 -->
    <div class="content">
      <div class="one">
        <img src="../../static/top_bg_web.png" class="">
        <div class="one_text">
          <div style="font-size: 2.5rem;margin-bottom: 1.875rem;">
            伴侣互动
          </div>
          <div class="">
            <p>更好地了解彼此，并增进彼此的感情</p>
            <p>加强沟通和信任，提升合作能力</p>
            <p>创造难忘回忆，减轻压力，培养共同兴趣</p>
            <p>增加互动和笑声，促进身心放松，确保关系的新鲜感和激情。</p>
            <div class="top_line"> </div>
          </div>

        </div>
      </div>
      <!-- 关于我们 -->
      <div class="two">
        <div class="about">
          <div style="font-size: 1.875rem;margin-bottom: 1.25rem;">
            <b>关于我们</b>
            ——
            <b>伴侣互动</b>
          </div>
          <div class="about_text">
            <p class="margin_top_ten">-一款有趣的情侣游戏，旨在增进情侣之间的了解和亲密感;</p>
            <p class="margin_top_ten">-提供了大量精心设计的问题，涵盖了各种主题，包括关于彼此的喜好、习惯、回忆和梦想等;</p>
            <p class="margin_top_ten">-根您的伴侣可以在自定义的时间限制内进行问答，并根据答案的准确性和速度来获得得分;</p>
            <p class="margin_top_ten">-更好地相互了解和交流，同时增加彼此之间的互动。</p>
            <div class="down_but">
              <a href="javascript:void(0)"><img src="../../static/Android_web.png"></a>
              <a href="javascript:void(0)"><img src="../../static/iphone_web.png"></a>
            </div>
          </div>
        </div>
        <div class="adout_img">
          <img class="adout_img_o" src="../../static/bg_web.png">
        </div>

      </div>
      <!-- 解决方案（轮播） -->
      <div class="three">
        <div class="" style="text-align: center;margin-bottom: 1.875rem;"> 解决方案 </div>
        <div class="left_shu" @click="arrowClick('left')">
          <img src="../../static/jian_left_web.png">
        </div>
        <div class="right_shu" @click="arrowClick('right')">
          <img src="../../static/jian_right_web.png">
        </div>
        <el-carousel ref="cardShow" trigger="click" arrow="never" style="width: 80%;margin: auto;"
          indicator-position="outside" :autoplay="false">
          <el-carousel-item v-for="item in 2" :key="item">
            <div class="shuffl_box">
              <div class="shuffl_box_img">
                <img class="shuffl_img" src="../../static/lun_web.png">
              </div>
              <div class="three_text">
                <p>两个人之间关系日渐冷淡？</p>
                <p>是哪里出了问题？</p>
                <div class="flex">
                  <img src="../../static/jiaocha.png" style="width: 50px;">
                  <div id="">解决方案</div>
                </div>
                <p>情侣游戏创造难忘回忆，减轻压力，培养共同兴趣，</p>
                <p>帮你维持关系的新鲜感和激情。</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>
      <!-- 联系我们 -->
      <div style="text-align: center;font-size: 2.25rem;">联系我们</div>
      <div class="four">
        <div class="four_left">
          <div style="font-size:1.875rem;margin-bottom: 1.25rem;">深圳市金矿网络科技有限公司</div>
          <p>地址：深圳市宝安区金宝科创中心1015</p>
          <p>电话：4006-352-107</p>
          <p>邮编：518101</p>
          <!-- <p>备案号：<a href="https://beian.miit.gov.cn/">粤ICP备18111848号-4</a></p> -->
        </div>
        <div class="four_right">
          <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler">
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
              <bm-label content="深圳市宝安区金宝科创中心1015" :labelStyle="{ color: 'red', fontSize: '15px' }"
                :offset="{ width: -35, height: 30 }" />
            </bm-marker>
          </baidu-map>
        </div>
      </div>
      <!--  -->
      <div class="filing">

        <span style="padding-right:10px">深圳市金矿网络科技有限公司</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#ffffff">网站备案号：粤ICP备18111848号-11</a>
        <a href="https://beian.miit.gov.cn/" target="_blank"
          style="margin-left: 20px; color:#ffffff">APP备案号：粤ICP备18111848号-16A</a>

      </div>
      <!-- <div style="margin-top: 6.25rem;">

      </div> -->
    </div>
    <!-- logo -->
    <div class="login_box">
      <img src="../../static/logo_web.png">
    </div>
    <!-- 导航区域 -->
    <ul class="navs">
      <li :class="{ active: active === 0 }" @click="scrollTo(0)">
        首页
      </li>
      <li :class="{ active: active === 1 }" @click="scrollTo(1)">
        关于我们
      </li>
      <li :class="{ active: active === 2 }" @click="scrollTo(2)">
        解决方案
      </li>
      <li :class="{ active: active === 3 }" @click="scrollTo(3)">
        联系我们
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      active: 0,// 当前激活的导航索引
      iphoneSrc: "https://apps.apple.com/cn/app/%E7%89%9B%E7%89%9B%E7%9D%A1%E7%9C%A0-%E6%AD%A3%E5%BF%B5%E5%8A%A9%E7%9C%A0%E8%A7%A3%E5%8E%8B%E5%B0%8F%E4%B8%93%E5%AE%B6/id1587297855",

      //腾讯地图
      map: null,

      // addressKeyword: "",
      center: { lng: 113.886328, lat: 22.55667 },
      zoom: 3
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll, false)
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    arrowClick(val) {
      if (val === 'right') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
    handler({ BMap, map }) {
      console.log(BMap, map)
      this.center.lng = 113.886328
      this.center.lat = 22.55667
      this.zoom = 15
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll('.content >div')
      // 所有锚点元素的 offsetTop
      const offsetTopArr = []
      navContents.forEach(item => {
        offsetTopArr.push(item.offsetTop);
      })
      // 获取当前文档流的 scrollTop
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      this.active = navIndex
    },
    // 跳转到指定索引的元素
    scrollTo(index) {
      this.active = index
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      const targetOffsetTop = document.querySelector(`.content >div:nth-child(${index + 1})`).offsetTop
      // 获取当前 offsetTop
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp()
      } else {
        // 往下滑
        smoothDown()
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown)
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          requestAnimationFrame(smoothUp)
        }
      }
    }
  }
}
</script>

<style scoped>
.filing {
  margin-top: 20px;
  background: #30333a;
  color: #ffffff;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 内容区的样式 */
.content {
  background-color: white;
  width: 100%;
  overflow: hidden;
}

.content .one {
  position: relative;

}

.content .one>img {
  width: 100%;
}

.content .one_text {
  position: absolute;
  color: #ffffff;
  width: 80%;
  text-align: right;
  top: 20%;
  right: 10%;

}

.one p {
  font-size: 1.25rem;
  text-align: right;
  line-height: 2.5rem;
}

.top_line {
  width: 6.25rem;
  height: 0.1875rem;
  background-color: #ffffff;
  margin-top: 1.25rem;
  position: absolute;
  right: 0.625rem;
  bottom: -1.875rem;

}

/* 关于 */
.content .two {
  margin-top: 1.875rem;
  position: relative;
  /* height: 18.75rem; */
  width: 100%;
  display: flex;
  justify-content: center;
}

.two .about {
  width: 40%;
  padding-right: 3.125rem;
}

.content .two .adout_img {
  width: 40%;
  overflow: hidden;
}

.two .adout_img .adout_img_o {
  width: 100%;
}

.margin_top_ten {
  margin-top: 1.25rem;
}

.about .about_text {
  text-align: left;
  padding: 0 0.3125rem 0 6.25rem;
  font-size: 1.125rem;
  line-height: 1.875rem;
}

.two .down_but {
  margin-top: 3.125rem;
  display: flex;
  padding: 0 1.25rem;
  box-sizing: border-box;
  justify-content: space-between;
}

.two .down_but a {
  width: 30%;
}

.two .down_but img {
  width: 100%;
}

/* 解决方案 （轮播）*/

.three {
  position: relative;
  margin-top: 6.25rem;
  background-color: #000000;
  color: #ffffff;
  padding: 50px 0;
  font-size: 2.25rem;
  margin-bottom: 3.125rem;

}

.shuffl_box_img {
  box-shadow: -1rem -1rem 1rem #9e9e9e;
}

.shuffl_box {
  display: flex;
}

.shuffl_box>div {
  width: 50%;
  /* height: 12.5rem; */
}

.shuffl_box .shuffl_img {
  width: 100%;

}

/deep/ .el-carousel__container {}

.three_text {
  font-size: 1rem;
  text-align: left;
  padding-left: 1.875rem;
  line-height: 1.875rem;
}

.flex {
  margin: 1.875rem 0;
  display: flex;
  align-items: center;
}

.left_shu>img {
  width: 100%;
}

.right_shu>img {
  width: 100%;
}

.left_shu {
  position: absolute;
  width: 1.875rem;
  height: 1.875rem;

  text-align: center;
  top: 50%;
  left: 5%;
  font-size: 0.625rem;
  line-height: 1.875rem;
  margin-top: -0.9375rem;
}

.right_shu {
  line-height: 1.875rem;
  position: absolute;
  width: 1.875rem;
  height: 1.875rem;
  /* border: #aaaaaa 1px solid; */
  text-align: center;
  top: 50%;
  right: 5%;
  font-size: 0.625rem;
  margin-top: -0.9375rem;
}

/*  联系我们*/
.four {
  display: flex;
  margin-top: 3.125rem;
  justify-content: center;

}

.four>div {
  width: 40%;
}

.four .four_left {
  text-align: left;
  padding-left: 6.25rem;
  box-sizing: border-box;
  font-size: 1.25rem;

}

.four .four_left p {
  line-height: 2.5rem;
}

.four .four_right {}

.map {
  width: 100%;
  height: 400px;
}

.content>div {
  width: 100%;
  /* height: 600px;
    font-size: 36px;
    padding: 20px; */
  /* background-color: #7ec384; */
}

.content div:nth-child(2n) {
  /* background-color: #847ec3; */
}

/* 导航栏的样式 */
.navs {
  position: fixed;
  top: 0;
  right: 10%;
  /* background-color: #efefef; */
  display: flex;
  z-index: 1000;
}

.navs li {
  padding: 1.25rem 3.125rem;
  line-height: 1.6;
  font-size: 1.25rem;
  list-style: none;
  color: #FFFFFF;
  background: rgba(0, 0, 0, .5);


}

/* 当导航被点亮后改变颜色 */
.navs .active {
  color: #ff2b2b;
  /* background-color: #e2e2e2; */
}

.login_box {
  width: 3.75rem;
  position: fixed;
  top: 0.625rem;
  left: 10%;
  z-index: 1000;
}

.login_box img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue